export default [
  { value: "OWNER", label: "Owner" },
  { value: "FURNISHED", label: "Tenant - furnished" },
  { value: "UNFURNISHED", label: "Tenant - unfurnished" },
  { value: "PARENTS", label: "Living with parents" },
  { value: "OTHER", label: "Other" }
];
